import {Injectable} from "@angular/core";

@Injectable()
export class StringUtils {

  /*
    Workaround to fix problem in TransferState cache and content which includes '</script>'
   */

  escapeTransferStateCacheData(data: string): string {
    return data.replace(/<\/script>/g, 'END_SCRIPT_TAG');
  }

  unescapeTransferStateCacheData(data: string): string {
    return data.replace(/END_SCRIPT_TAG/g, '</script>');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/stringutils.ts